import React from "react";
import "../../styles/solutions/SolutionsIntro.css";

const SolutionsIntro = () => {
  return (
    <section className="sol-intro">
      <div className="sol-intro__container reveal">
        <h2 className="sol-intro__title">Technology Solutions Built for Growth</h2>
        <p className="sol-intro__text">
          Iyconsoft provides innovative digital platforms that empower businesses, institutions,
          governments, and individuals through secure communication, intelligent ticketing,
          digital collections, and virtual voting solutions.
        </p>
      </div>
    </section>
  );
};

export default SolutionsIntro;
